import {Fragment} from "react";
import './govSpinner.scss';
import govLoader from './../../../assets/img/govLoader.gif';

const GovSpinner = (props) => {
    return(
        <Fragment>
            {props.show &&
                <div id="overlay">
                    <div id="spinner-container">
                        <div id="spinner-items">                                
                            <img src={govLoader} width="100px" height="100px"></img>
                        </div>
                    </div>
                </div>               
            }
       </Fragment>
    )
};
export default GovSpinner;

